import { Component, OnInit, signal } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { PurchaseAdminDashboardService, UpcomingVehicleDto } from '../purchase-dashboard.service';
import { PaginationComponent } from 'app/shared/components/pagination/pagination.component';
import { DatePipe } from '@angular/common';
import { MatSortModule } from '@angular/material/sort';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { environment } from 'app/environments/environment';
import { TranslocoPipe } from '@jsverse/transloco';
import { AlertService } from 'app/core/services/alert.service';

@Component({
  selector: 'app-upcoming-vehicles',
  templateUrl: './upcoming-vehicles.component.html',
  styleUrls: ['./upcoming-vehicles.component.css'],
  imports: [MatTableModule, PaginationComponent, DatePipe, MatTableModule, MatButtonModule, MatIconModule,
    MatSortModule, TranslocoPipe
  ]
})
export class UpcomingVehiclesComponent implements OnInit {
  environment = environment;

  displayedColumns: string[] = [
    'Intern number and model',
    'Estimated arrival',
    'Vehicle link'
  ];

  dataSource = signal<UpcomingVehicleDto[]>([]);

  constructor(public purchaseAdminService: PurchaseAdminDashboardService, private alert: AlertService) {
    this.getVehicles();
  }

  ngOnInit() {
    console.log(this.environment.apiUrl);
  }
  getVehicles() {
    this.purchaseAdminService.getUpcomingVehicles().subscribe({
      next: (response) => {
        this.dataSource.set(response.result!);
        console.log(this.dataSource());
        this.purchaseAdminService.upcomingVehiclesParams.update((currentParams) => ({
          ...currentParams, // Spread the existing state
          pagination: response.pagination!
        }));
      },
      error: (error) => {
        this.alert.errorFromHttp(error);
      }
    });
  }
  openDetails(id: string) {
    console.log(id);
    const url = `${environment.legacyUrl}vehicle/edit/${id}`;
    window.open(url);
  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
}
